<template>
    <div class="well" v-if="dataset.permission">
        <i class="fas fa-caret-square-down" @click="expand()" title="Expand elements"></i>
        <a @click="expand()"> {{ dataset.name }} </a>
        <a class="pull-right" :href="objectUrl + dataset.id" target="_blank">
            <i class="fal fa-external-link" title="Open data set in new tab" />
        </a>
        <!--
            v-html is dangerous and should only be used in certain situations
            These definitions are bleached on entry to the database
            TODO: look for a better way to render this information
            e.g. such as - render a smaller definition which only has plain text
         -->
        <p v-html="dataset.definition" />

        <div v-if="isExpanded" >
            <dataset-details :id="dataset.id" />
        </div>
    </div>
    <div class="well" v-else>
        <p><em>You do not have permission to view this data set</em></p>
    </div>
</template>

<script>
import DatasetDetails from 'src/components/dataset/components/DatasetDetails.vue'

export default {
    name: "DatasetDisplay",
    components: {
        DatasetDetails
    },
    props: {
        // The dataset which is rendered in this component
        dataset: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        isExpanded: false,
        objectUrl: '/item/',
    }),
    methods: {
        expand: function() {
            this.isExpanded = !this.isExpanded
        },
    }
}
</script>

<style scoped>
a {
    cursor: pointer;
}
</style>
